import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useFortuneData } from '../contexts/FortuneContext';
import '../styles/ResultPage.css';

const ResultPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { selectedProduct, fortuneResult, getFortuneHistory } = useFortuneData();
  const [result, setResult] = useState(null);

  useEffect(() => {
    // Redirect to home if no product is selected
    if (!selectedProduct) {
      navigate('/');
      return;
    }

    // Get the latest fortune result from history
    const history = getFortuneHistory();
    if (history.length > 0) {
      setResult(history[0].result);
    } else {
      navigate('/');
    }
  }, [selectedProduct, fortuneResult, navigate, getFortuneHistory]);

  if (!result) {
    return <div className="loading">Loading...</div>;
  }

  return (
    <div className="result-page">
      <div className="page-header">
        <Link to="/" className="back-button">
          <span>←</span>
        </Link>
        <h1>{t('result_title')}</h1>
      </div>

      <div className="result-content">
        <div className="result-header">
          <h2>{t(selectedProduct.titleKey)}</h2>
          <p className="result-date">
            {new Date(result.date).toLocaleDateString()}
          </p>
        </div>

        <div className="result-body">
          <p className="result-description">
            {t('result_desc')}
          </p>

          <div className="fortune-result">
            {/* In a real app, this would be structured based on the actual result */}
            <p className="fortune-text">{result.content}</p>
          </div>

          <div className="result-details">
            <h3>{t('product_includes')}</h3>
            <ul className="details-list">
              {selectedProduct.details.map((detail, index) => (
                <li key={index}>
                  <h4>{t(detail)}</h4>
                  <p>
                    {/* This would be filled with actual content from the API */}
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. 
                    Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                  </p>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="result-actions">
          <Link to="/" className="home-button">
            {t('home')}
          </Link>
          <Link to="/history" className="history-button">
            {t('history')}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ResultPage;
